var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11119 9.88889C10.5658 9.88889 12.5556 7.89904 12.5556 5.44444C12.5556 2.98985 10.5658 1 8.11119 1C5.65659 1 3.66675 2.98985 3.66675 5.44444C3.66675 7.89904 5.65659 9.88889 8.11119 9.88889Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2222 16.9998C15.2222 15.1138 14.473 13.3051 13.1394 11.9715C11.8058 10.6379 9.9971 9.88867 8.11111 9.88867C6.22513 9.88867 4.41639 10.6379 3.0828 11.9715C1.7492 13.3051 1 15.1138 1 16.9998",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.dd3fa856caf34f99c1feccd09e106638.svg";
export { ForwardRef as ReactComponent };